const setTimeRange = (n = 'day', m = 1) => {
  const start = dayjs().subtract(m, n).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0)
  const end = dayjs().set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 59)

  return [start.valueOf(), end.valueOf()]
}

export default setTimeRange
